var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFibLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5609_5834)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 12,
    fill: "#AD826E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.358 54H19.298V29.724H32.864V32.41H22.358V41.012H32.218V43.698H22.358V54ZM43.7629 54H34.9909V52.232L37.8469 51.586V32.172L34.9909 31.492V29.724H43.7629V31.492L40.9069 32.172V51.586L43.7629 52.232V54ZM55.3863 29.724C57.4037 29.724 59.0923 29.9167 60.4523 30.302C61.835 30.6873 62.8663 31.322 63.5463 32.206C64.249 33.09 64.6003 34.2687 64.6003 35.742C64.6003 36.694 64.419 37.544 64.0563 38.292C63.7163 39.0173 63.195 39.6293 62.4923 40.128C61.8123 40.604 60.9737 40.9327 59.9763 41.114V41.284C60.9963 41.4427 61.9143 41.7373 62.7303 42.168C63.569 42.5987 64.2263 43.2107 64.7023 44.004C65.1783 44.7973 65.4163 45.8287 65.4163 47.098C65.4163 48.5713 65.0763 49.8293 64.3963 50.872C63.7163 51.892 62.7417 52.674 61.4723 53.218C60.2257 53.7393 58.7297 54 56.9843 54H48.4503V29.724H55.3863ZM55.9983 40.06C58.0837 40.06 59.5117 39.7313 60.2823 39.074C61.053 38.394 61.4383 37.3967 61.4383 36.082C61.4383 34.7447 60.9623 33.7927 60.0103 33.226C59.081 32.6367 57.585 32.342 55.5223 32.342H51.5103V40.06H55.9983ZM51.5103 42.61V51.416H56.4063C58.5597 51.416 60.0557 50.9967 60.8943 50.158C61.733 49.3193 62.1523 48.22 62.1523 46.86C62.1523 45.9987 61.9597 45.2507 61.5743 44.616C61.2117 43.9813 60.5883 43.494 59.7043 43.154C58.843 42.7913 57.6643 42.61 56.1683 42.61H51.5103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5609_5834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibLogo);
export default __webpack_public_path__ + "static/media/FIB_Logo.c9ff8badbd6c47090bb20a46a1d5a491.svg";
export { ForwardRef as ReactComponent };